import React from 'react'
import { SuccessIcon, StatusText, VoucherStatusContainer } from './VocuherSuccess.style'

const VoucherSuccess = () => {
    return (
        <VoucherStatusContainer>
            <SuccessIcon className="wemolo-check-circle" />

            <StatusText>Gutschein hinzugefügt</StatusText>
        </VoucherStatusContainer>
    )
}

export default VoucherSuccess
